import {
    SET_NOTIFICATIONS,
    UPDATE_NOTIFICATIONS
} from '../types';

const INITIAL_STATE = []

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_NOTIFICATIONS:
            return action.payload || [];
        case UPDATE_NOTIFICATIONS:
            return action.payload.concat(state);
        default:
            return state;
    }
}